import { cn } from '@lib/util/cn';
import Image from 'next/image';

type ImageBadgeProps = {
  src: string;
  alt: string;
  className?: string;
  imageClassName?: string;
  as?: 'div' | 'li';
  disabled?: boolean;
};

export function ImageBadge({
  src,
  alt,
  className,
  imageClassName,
  as: Tag = 'div',
  disabled,
}: ImageBadgeProps) {
  return (
    <Tag
      className={cn(
        'w-[50.5px] desktop:w-auto desktop:flex-1 aspect-[208/134] bg-white rounded relative desktop:min-w-0 border',
        disabled ? 'border-brand-neutral-300' : 'border-border-semantic-soft',
        className,
      )}
    >
      <Image
        src={src}
        alt={alt}
        fill
        className={cn(
          imageClassName,
          'object-contain p-2.5',
          disabled && 'grayscale opacity-60',
        )}
      />
    </Tag>
  );
}
